import type { AttachmentDetails, Feature } from 'api';

import { AttachmentDetailsBreakdown } from '../AttachmentDetailsBreakdown/AttachmentDetailsBreakdown';
import { PetMaterialBreakdown } from '../PetMaterialBreakdown/PetMaterialBreakdown';

type AluVariantProps = {
  variant: 'alu' | 'briquette';
  attachmentDetails: AttachmentDetails;
  targetWeightPercentage: number;
};

type PetVariantProps = {
  variant: 'pet';
  materials: Record<string, Feature | number>;
};

type Props = AluVariantProps | PetVariantProps;

export const MaterialAiBreakdown = ({ ...props }: Props) => {
  return (
    <>
      {props.variant === 'alu' || props.variant === 'briquette' ? (
        <AttachmentDetailsBreakdown
          attachmentDetails={props.attachmentDetails}
          targetWeightPercentage={props.targetWeightPercentage}
        />
      ) : null}
      {props.variant === 'pet' && <PetMaterialBreakdown features={props.materials} />}
    </>
  );
};
